import { Component, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { SeConstraintNotifierService } from '@se/se.platform.base';
import { Logger } from '@se/se.platform.base';

import { AbstractControlComponent } from '../abstract-control';

@Component({
    selector: 'cp-placeholder',
    templateUrl: './placeholder.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CpPlaceholderComponent extends AbstractControlComponent {
    constructor(cdr: ChangeDetectorRef, constraintNotifierService: SeConstraintNotifierService, logger: Logger) {
        super(cdr, constraintNotifierService, logger);
    }

    protected onModelChange() {
        return false;
    }

    protected init() {
        // Nulla da fare.
    }
}
